// extracted by mini-css-extract-plugin
export default {"wrap":"Timeline_wrap__LtanE","list":"Timeline_list__xSt7A","empty":"Timeline_empty__J2dUd"};